module.exports = __webpack_public_path__ + "static/media/internal_staff_icon.f32a64f2.png";